<template>
  <v-container  ref="barWrapper" fluid fill-height  ma-0 pa-0 >
    <loading-circle
      :show="loader"
    />

    <device-bar
      :open="true"
      noclose
      modalMode
      :modalActive="getData"
      @update=""
      @load-devices=""
      @close=""
    />
  </v-container>
</template>

<script>

import loadingCircle from '@/nms/components/partials/loader.vue'
import DeviceBar from '@/nms/pages/device/device-bar.vue'

export default {

  name: 'LINKS_MODAL',

  components: {
    loadingCircle,
    DeviceBar,
  },

  props: {
    data: {
      type: Object,
      default: () => ({})
    },
  },

  data: () => ({

    loader: false,

    devices: [],

    bar: {
      location: {
        create: {
          open: false
        },
        update: {
          open: false
        },
      },
      device: {
        open: false
      },
      book: {
        activeBook: null,
        open: false
      },
    },

    options: {
      columns: {
        text: {
          width: '40%'
        },
        timestamp: {
          width: '40%'
        },
        timestamp: {
          width: '40%'
        },
        actions: {
          width: '40%'
        },
        endpoint: {
          width: '40%'
        },
        check: {
          width: '20%'
        },
      },
    },

    filter: null,
    search: '',

    table: {
      columns: [
        {
          title: 'device',
          value: 'name',
          type: 'text',
          width: '50%'
        },
        {
          title: 'device_type',
          value: 'device_type',
          type: 'text',
          width: '30'
        },
        {
          title: 'consume',
          value: 'consume',
          type: 'text',
          width: '20%'
        }
      ],
      rows: []
    },

  }),

  computed: {
    getData: function () {
      return this.data
    },
  },

  watch: {},

  created () {
    this.setup()
  },

  mounted () {},

  updated () {},

  beforeDestroy () {},

  methods: {

    setup: async function () {
      this.loadDevices()
      this.reset()
      this.statusUnsubscribe('LINKS_MODAL')
    },

    loadDevices: async function () {
      try {
        this.setLoader('loadDevices', true)
        this.devices = []
        let data$ = await this.getData.getLinks({compute: 'is_used'})
        if(data$ && data$.length) {
          data$.forEach(child => {
            if(child.cls == 'device') {
              this.devices.push(child)
            }
          })
          this.setLoader('loadDevices', false)
        } else {
          this.setLoader('loadDevices', false)
        }
        this.prepareTable()
      }
      catch(err) {
        console.error('CATCH', this.$options.name, 'loadDevices', err)
        this.loader = false
      }
    },

    setLoader: function(name, status) {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    prepareTable: async function () {
      try {
        if(this.devices.length) {
          this.loader = true
          this.devices.forEach(child => {
            let row$ = {}
            row$.name = child.name
            row$.device_type = child.device_type
            row$.consume = child.consume
            row$.$id = child.$id
            this.table.rows.push(row$)
          })
          this.loader = false
          this.statusSubscribe(this.devices, 'LINKS_MODAL')
        }
      }
      catch(err) {
        console.error('CATCH', this.$options.name, 'prepareTable', err)
        this.loader = false
      }

    },

    statusSubscribe: async function (arr, group) {
      this.$store.dispatch('measuresSubscribeInit', {
        name: 'addStatus',
        group: group,
        listener: 'status'
      })
      if(arr.length) {
        arr.forEach((item, i) => {
          if(item.$id) {
            this.$store.dispatch('addStatusKey',item)
          }
        });
        await this.$bridge.subscribe(arr.map(obj => obj.$id))
      }
    },

    subscribeHandler: function (e) {
      if (e.$id) {
        this.$store.dispatch('addStatus', e)
      }
    },

    statusUnsubscribe: function (group) {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },

    reset: function () {
      this.table.rows = []
    }
  }
}
</script>

<style scoped lang="less">

</style>
